module.exports = __webpack_public_path__ + "img/pd3.2ca65c5a.jpg";